@if (showsBlock()) {
  @if (baseItem(); as base) {
    <div class="px-4 py-2" [attr.data-testid]="testId()">
      <p class="mb-6 text-sm opacity-80">{{ scaleHintKey() | transloco }}</p>

      <div class="space-y-5" [attr.data-testid]="testId() + '-rows'">
        @for (row of rows(); track row.id) {
          <div [attr.data-testid]="testId() + '-row-' + row.id">
            <div class="flex items-baseline justify-between gap-4">
              <span
                class="min-w-0 truncate"
                [class.opacity-60]="row.rightIsStronger"
                [class.font-medium]="row.leftIsStronger"
                [attr.data-testid]="testId() + '-left-' + row.id"
              >
                {{ base.translations | translateDirectus }}
              </span>
              <span
                class="min-w-0 truncate text-end"
                [class.opacity-60]="row.leftIsStronger"
                [class.font-medium]="row.rightIsStronger"
                [attr.data-testid]="testId() + '-right-' + row.id"
              >
                {{ row.translations | translateDirectus }}
              </span>
            </div>

            <div class="relative mt-2 h-5">
              <div
                class="absolute inset-x-0 top-1/2 h-3 -translate-y-1/2 overflow-hidden rounded-full bg-third-level"
              >
                <div
                  class="h-full bg-emerald-500 transition-all"
                  [style.margin-left.%]="row.fillLeft"
                  [style.width.%]="row.fillWidth"
                ></div>
              </div>

              <p-slider
                class="absolute inset-x-0 top-1/2 block -translate-y-1/2"
                [min]="sliderMin"
                [max]="sliderMax"
                [step]="1"
                [ngModel]="row.sliderValue"
                [disabled]="disabled()"
                [attr.data-testid]="testId() + '-slider-' + row.id"
                (ngModelChange)="onSliderChange(row.id, $event)"
              ></p-slider>
            </div>

            <p
              class="mt-2 text-center text-sm opacity-80"
              [attr.data-testid]="testId() + '-label-' + row.id"
            >
              @if (row.leftIsStronger) {
                {{ base.translations | translateDirectus }}: {{ row.scaleLabel }}
              } @else if (row.rightIsStronger) {
                {{ row.translations | translateDirectus }}: {{ row.scaleLabel }}
              } @else {
                {{ row.scaleLabel }}
              }
            </p>
          </div>
        }
      </div>

      @if (showsSaveButton()) {
        <div class="flex justify-end gap-2 mt-6">
          <app-project-step-save-button
            [loading]="saving()"
            [disabled]="saving()"
            (clicked)="onSave()"
          ></app-project-step-save-button>
        </div>
      }
    </div>
  }
}
